import { Injectable } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Injectable()
export class StateStackService {
    states = [];
    
    constructor(private stateService: StateService) {
    }

    clear() {
        this.states = [];
    }

    push(name: string, params: string) {
        var add = {
            name: name,
            params: params
        };
        this.states = [add].concat(this.states);
    }

    pop() {
        var ret = false;
        if (this.states.length) {
            ret = this.states[0];
            this.states = this.states.slice(1);
        }
        return ret;
    };

    back(defaultName, defaultParams) {
        var last: any = this.pop();

        if (last) {
            this.stateService.go(last.name, last.params);
        } else {
            this.stateService.go(defaultName, defaultParams || {});
        }
    };
}